import { Environment, getEnvironment } from '../config';

export function buildReceptionLink(reservationSlug: string, isWhiteLabel = false): string {
  const environment = getEnvironment();

  switch (environment) {
    case Environment.DEVELOPMENT: {
      return `http://localhost:3000/stay?slug=${reservationSlug}`;
    }

    case Environment.DUKE_NUKEM: {
      return `https://reception.dukenukem.test-bobw.com/stay=${reservationSlug}`;
    }

    case Environment.STAGING: {
      return `https://reception.staging-bobw.com/stay?slug=${reservationSlug}`;
    }

    case Environment.PRODUCTION: {
      if (isWhiteLabel) {
        return `https://guest.notahotel.co/${reservationSlug}`;
      }

      return `https://reception.bobw.co/stay?slug=${reservationSlug}`;
    }
  }
}

export function buildHoustonReservationDetailsLink(reservationId: string): string {
  const environment = getEnvironment();

  switch (environment) {
    case Environment.DEVELOPMENT: {
      return `http://localhost:5001/reservations/${reservationId}`;
    }

    case Environment.DUKE_NUKEM: {
      return `https://houston.dukenukem.test-bobw.com/reservations/${reservationId}`;
    }

    case Environment.PRODUCTION: {
      return `https://houston.bobw.co/reservations/${reservationId}`;
    }

    case Environment.STAGING: {
      return `https://houston.staging-bobw.com/reservations/${reservationId}`;
    }
  }
}
